import { useState } from "react";
import {
  FiHome,
  FiGrid,
  FiBook,
  FiUsers,
  FiSettings,
  FiBarChart2,
  FiHelpCircle,
  FiLogOut,
  FiBell,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import logo from '../../../../assets/newlogo.png';

const Sidebar = ({ isCollapsed }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("/marketplace/university");

  const menuItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: <FiHome />,
      link: "/marketplace/university",
    },
    // {
    //   id: "users",
    //   label: "Users",
    //   icon: <FiUsers />,
    //   link: "/marketplace/university/users",
    // },
     {
      id: "deans",
      label: "Deans",
      icon: <FiUsers />,
      link: "/marketplace/university/deans",
    },
    {
      id: "categories",
      label: "Departments",
      icon: <FiGrid />,
      link: "/marketplace/university/departments",
    },
    
    {
      id: "announcements",
      label: "Announcements",
      icon: <FiBell />,
      link: "/marketplace/university/announcements",
    },
    // {
    //   id: "members",
    //   label: "Members",
    //   icon: <FiUsers />,
    //   link: "/marketplace/university/dashboard/members",
    // },
    // {
    //   id: "reports",
    //   label: "Reports",
    //   icon: <FiBarChart2 />,
    //   link: "/marketplace/university/dashboard/reports",
    // },
    // {
    //   id: "settings",
    //   label: "Settings",
    //   icon: <FiSettings />,
    //   link: "/marketplace/university/dashboard/settings",
    // },
  ];

  const logout = () => {
    localStorage.removeItem("access_token");
    navigate("/");
  };

  return (
    <div
      className={`bg-white border-r border-gray-200 h-screen fixed z-50 flex flex-col transition-all duration-300 ${
        isCollapsed ? "w-20" : "w-72"
      }`}
    >
      {/* Header */}
      <div className={`px-[28px] border-b border-gray-100 flex items-center ${isCollapsed ? 'justify-center' : 'justify-start'}`}>
        <div className={`flex items-center gap-3 ${isCollapsed ? 'justify-center' : ''}`}>
          <div className="flex items-center justify-center">
            <img 
              src={logo} 
              alt="axionnest" 
              className="w-20 h-20 object-contain cursor-pointer"
              onClick={() => navigate('/home')}

            />
          </div>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="flex-1 p-4 overflow-y-auto">
        <ul className="space-y-1">
          {menuItems.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => {
                  setActiveTab(item.link);
                  navigate(item.link);
                }}
                className={`w-full flex items-center p-3 rounded-xl transition-all duration-200 ${
                  activeTab === item.link
                    ? "bg-[#e8f0f7] text-[#0f6abf]"
                    : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                }`}
              >
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                  activeTab === item.link 
                    ? "bg-white text-[#0f6abf]" 
                    : "bg-gray-100 text-gray-600"
                }`}>
                  <span className="text-lg">{item.icon}</span>
                </div>
                {!isCollapsed && (
                  <span className="ml-3 font-medium text-sm">{item.label}</span>
                )}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {/* Footer Buttons */}
      <div className="p-4 border-t border-gray-100">
        <button className={`w-full flex items-center p-3 text-gray-600 rounded-xl hover:bg-gray-50 hover:text-gray-900 transition-all duration-200 ${
          isCollapsed ? 'justify-center' : ''
        }`}
         onClick={()=>navigate('/marketplace/feed')}
        >
          <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center">
            <FiHelpCircle className="text-lg text-gray-600" />
          </div>
          {!isCollapsed && <span className="ml-3 font-medium text-sm">Saw Feeds</span>}
        </button>
        
        <button
          onClick={logout}
          className={`w-full flex items-center p-3 text-gray-600 rounded-xl hover:bg-gray-50 hover:text-gray-900 transition-all duration-200 mt-2 ${
            isCollapsed ? 'justify-center' : ''
          }`}
        >
          <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center">
            <FiLogOut className="text-lg text-gray-600" />
          </div>
          {!isCollapsed && <span className="ml-3 font-medium text-sm">Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;